import { useQuery } from "@tanstack/react-query"

import { usePartnerCode } from "@/features/PartnerCode"

import { bffApi } from "../apiClient"
import formatStartDate from "../helpers/formatStartDate"
import { Category } from "../models"
import queryKeys from "../queryKeys"

const useCategories = (resortExternalId: number, arrivalDate: Date) => {
  const formattedDate = formatStartDate(arrivalDate)
  const { partnerCode } = usePartnerCode()

  return useQuery<Category[]>({
    queryKey: queryKeys.categories(
      resortExternalId,
      formattedDate,
      partnerCode
    ),
    queryFn: async () => {
      const res = await bffApi.get<{
        categories: Category[]
      }>(`/categories`, {
        params: {
          resortId: resortExternalId,
          arrivalDate: formattedDate,
          partnerCode,
        },
      })

      return res.data.categories
    },
  })
}

export default useCategories
